module.exports = __webpack_public_path__ + "img/income.1d842e71.png";